/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <section class="wrapp-coin-card">
    <div class="enter-coin-card">
      <div class="coin-card-title">
        {{$t('enter-coin-card')}}
      </div>
      <b-form class="wrapp-coin-card__form">
        <div class="form-wrapper">
          <div class="wrapp-icon" @click.prevent="openScanReader">
            <svg class="o-icon"><use xlink:href="#qr-code"></use></svg>
          </div>
          <b-form-group>
            <base-input
              name="coin-card"
              v-model="coinCard"
              type="text"
              classInput="rounded"
              :readonly="disableForm"
              :validations="[
                {
                  condition: coinCardErrors.message.length > 0,
                  text:  coinCardErrors.message
                }
              ]"
            >
            </base-input>
          </b-form-group>
          <div class="wrapp-submit">
            <button type="submit" class="btn btn-secondary btn-secondary-small btn-secondary-with-icon btn-rounded justify-content-between" @click.prevent="submitForm" v-show="!disableForm">
              <span class="text">{{ $t('apply') }}</span>
              <svg class="o-icon"><use xlink:href="#check"></use></svg>
            </button>
          </div>
        </div>
      </b-form>
      <card-customer :customer="customer" :loyalty="loyalty" :rewards="rewards" ref="customer" />
      <card-rewards :rewards="rewards" ref="rewards" />
    </div>
  </section>
</template>

<script>
import { EventBus } from '@/helpers'
import BaseInput from 'theme/components/Form/BaseInput'
import CardCustomer from 'theme/components/CoinCard/CardCustomer'
import CardRewards from 'theme/components/CoinCard/CardRewards'
// import { toast } from 'theme/modules/notifications'
// import { mapGetters } from 'vuex'

export default {
  name: 'CoinCard',
  props: {
    customer: {
      type: Object,
      default: () => {}
    },
    loyalty: {
      type: Object,
      default: () => {}
    },
    rewards: {
      type: Array,
      default: () => []
    },
    cardNumber: {
      type: String,
      default: () => ''
    },
    disableForm: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      coinCard: '',
      coinCardErrors: {
        message: ''
      }
    }
  },
  methods: {
    init () {
      // init this one and other child
      this.$refs['customer'].init()
      this.$refs['rewards'].init()
    },
    submitForm () {
      if (this.coinCard.length) {
        this.$store.commit('ui/showLoader')
        return this.$store.dispatch('checkout/cartDetails', { cardCode: this.coinCard })
          .then((res) => {
            if (res) {
              return this.$emit('updateCard', res)
            }
          })
          .finally(() => {
            this.$store.commit('ui/hideLoader')
          })
      }
    },
    removeCoinCard () {
      return true
    },
    getFromScanner (code) {
      this.$store.commit('ui/setBottomActiveComponent', {})
      this.coinCard = code
      this.submitForm()
    },
    openScanReader () {
      const componentToLoad = import('theme/components/CodeScanner/CoinCardScanner.vue')
      this.$store.dispatch('ui/loadBottomActiveComponent', { component: componentToLoad })
      EventBus.$on('coin-card-scanner::detect', this.getFromScanner)
    }
  },
  watch: {
    cardNumber (newValue, oldValue) {
      if (oldValue !== newValue) {
        this.coinCard = newValue
      }
    }
  },
  destroyed () {
    EventBus.$off('coin-card-scanner::detect', this.getFromScanner)
  },
  components: {
    BaseInput,
    CardCustomer,
    CardRewards
  }
}
</script>
